<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_31" title="[31]"></span>
<h2 class="nobreak" id="pgepubid00007">CHAPTER IV<br class="calibre15"/>
<span class="small">DEER SHOOTING BY MOONLIGHT</span></h2>
</div>
<p class="calibre3"><span class="smcap">Night</span> found Dave and his uncle at the cabin of a
settler named Risley, an Englishman who had come
to the neighborhood a year before. Visitors were
far from frequent in those days and the newcomers
were made heartily welcome by the farmer and his
wife. The former insisted on helping them care for
their horses, while the latter bustled about to prepare
a substantial meal for their benefit.</p>
<p class="calibre3">“It does one good to set eyes on another face,”
remarked Uriah Risley, when they were gathered
around his rough-hewn table, partaking of a stew in
an iron pot set in their midst. “It is so different
here from life in Sussex, where we came from. The
good wife thought she should die of loneliness when
we first settled. But now she is somewhat used to
it. Is that not so, Catherine?”</p>
<p class="calibre3">“Truly it is, Uriah,” answered the spouse. “In
dear Lenfield Glen we had neighbors by the score,
and the smoke of a hundred chimneys went up of a
sunrise; here we have nothing but trees and water<span id="Page_32" title="[32]"></span>
and blue sky until I am weary of gazing upon it
all.”</p>
<p class="calibre3">“It won’t be so for many years,” put in Joseph
Morris. “The settlers are coming in more and
more every year.”</p>
<p class="calibre3">“I’ve heard some talk of a company being started
to take up the lands in the West,” said Uriah Risley.
“I believe Lord Fairfax and others are behind
the scheme.”</p>
<p class="calibre3">“To get ahead of the French?”</p>
<p class="calibre3">“Aye. I’d like to see the thing go through, too—’twould
bring more faces to this district.”</p>
<p class="calibre3">“I cannot say that I object to the solitude, so long
as the Indians do not molest us,” said Joseph Morris.
“I love the woods and the lonely rivers—I have
grown so used to them that they seem part of my
life.”</p>
<p class="calibre3">Uriah Risley nodded to show he understood. “I
believe you. But Catherine and I are used to having
friends around. Why, the poor wife nearly cried
her eyes out the first night we were here—nay,
nay, do not deny it, for it’s nothing to be ashamed
of, Caddy. She said the mountains and the tall,
black-looking trees seemed to fairly press in on her.”</p>
<p class="calibre3">“And they do that—at times,” answered Joseph
Morris. “I know the feeling. But it will pass
away, Mistress Risley, and you will get to love the<span id="Page_33" title="[33]"></span>
trees as you love the furniture of your house—and
know them just as well.”</p>
<p class="calibre3">The supper was not a dainty affair, but the riders
were hungry and ate long and heartily. After the
meal Dave insisted upon helping Mrs. Risley get in
the wood and water, while his uncle and the owner
of the cabin sat by the doorstep smoking and talking.</p>
<p class="calibre3">The moon was rising over the distant trees when
of a sudden Joseph Morris leaped up and reached
for his rifle, which he had placed behind the kitchen
door, “A deer—down at the end of the clearing,
where the brook makes a turn!” he whispered. “If
you don’t make a noise perhaps I can bring him
down.”</p>
<p class="calibre3">“It’s a long shot,” returned Uriah Risley, who
was no marksman at all, measured by the proficiency
of the old pioneers. “I can scarcely see the animal.”</p>
<p class="calibre3">“I see him,” put in Dave. “There, he is turning
up the brook!”</p>
<p class="calibre3">By this time Joseph Morris had his rifle and was
examining the flint-lock. The weapon was in good
condition for use, and he tiptoed his way out of the
cabin, and crouching low, made for a stump standing
fifty feet closer to the brook.</p>
<p class="calibre3">“Let us keep in the shadow,” whispered Dave,
who wished to give his uncle all the advantage possible,
and the Englishman, his wife, and the boy<span id="Page_34" title="[34]"></span>
huddled up in the sheltered doorway. A silence of
several minutes followed. Joseph Morris had gained
the stump and was on his knees behind it, with his
rifle barrel leveled across the top.</p>
<p class="calibre3">“I don’t see the deer anymore,” came in a husky
tone from Uriah Risley. “He must have got
frightened and run away.”</p>
<p class="calibre3">“No, he is there, behind the brush,” answered
Dave. “Hist! here he comes!”</p>
<p class="calibre3">All became silent, and Mrs. Risley breathed hard
in anticipation of hearing the rifle go off. Step by
step the deer came out of the shadow of the forest
until the brookside was gained. For a moment it
disappeared, behind some brush, then came into view
at the other end. Its head was down and only its
back could be seen.</p>
<p class="calibre3">Dave looked at his uncle. Joseph Morris still
rested behind the stump as motionless as a statue.
Presently he let out a short, sharp, hissing whistle.
Instantly the head of the deer came up, and the
animal was all attention, staring in the direction
from whence the sound had come.</p>
<p class="calibre3">Bang! The shot from the rifle echoed and re-echoed
through the night air and across the distant
mountain. The deer gave a mighty leap into the
air, then fell with a splash into the brook and lay
kicking convulsively.</p>
<p class="calibre3"><span id="Page_35" title="[35]"></span>“Good! You’ve got him!” shouted Dave, and
ran down the clearing with his uncle behind him
and the Risleys bringing up the rear. By the time
they reached the game the deer had ceased to kick
and was calmly breathing its last, with eyes wide
open in painful wonder. They hauled the animal out
of the brook, and Joseph Morris speedily put it out
of its misery by cutting its throat.</p>
<p class="calibre3">“A fine shot!” remarked Dave. “Straight
through the neck. It’s something to be proud of—especially
in this uncertain light.”</p>
<p class="calibre3">“A remarkable shot!” cried Uriah Risley. “I
couldn’t do that if I practised a thousand years!
And you took your time, too.”</p>
<p class="calibre3">“The brush hid him a bit and I wanted him to
raise his head,” explained Mr. Morris. “Yes, it
was a good shot, but I’ve seen plenty equal to it.
You can have venison for a week now, and longer.”</p>
<p class="calibre3">“Don’t you want the meat?”</p>
<p class="calibre3">“No, I’ll take the skin and leave the meat to you
for your hospitality to Dave and me. Perhaps we’ll
stop again on our return from Annapolis.”</p>
<p class="calibre3">“Do, and we’ll do our best by you,” put in Mrs.
Risley. “I’ve been longing for some fresh venison
these three weeks back, but Uriah was not equal to
bringing a deer down.”</p>
<p class="calibre3">“You should practice more with your rifle,” said<span id="Page_36" title="[36]"></span>
Joseph Morris, to the cabin owner. “A pound or
two spent on powder and ball is often well invested.
Dave, here, I am proud to say, can shoot almost as
well as myself, and so can my own boys at home.”</p>
<p class="calibre3">“I will take the advice,” answered Uriah Risley.
“For such deer meat as this is certainly worth some
shillings, not to speak of the worth of the hide.”</p>
<p class="calibre3">The game was brought up to the house, and by the
light of a pitch pine torch, the Morrises skinned it
and then turned the carcass over to the Risleys.</p>
<p class="calibre3">“Don’t leave it outside,” said Joseph Morris.
“This is the night for wolves to be around, and they
will make short work of the meat if once they get
at it.” And the meat was hung up at the roof of a
cattle shed adjoining the cabin.</p>
<p class="calibre3">The Risley homestead boasted of but two rooms,
the living apartment and a small bedroom. Under
such conditions there was nothing for Dave and his
uncle to do but to wrap themselves in their blankets
and make themselves comfortable before the kitchen
fire. But this was no new experience for them and
Dave slept as soundly as though in his corded bed at
home. Once during the night he heard the wolves
at the cattle shed, but they soon went off disappointed,
and did not return.</p>
<p class="calibre3">The Morrises expected to make an early start, but
Mrs. Risley would not hear of their leaving without<span id="Page_37" title="[37]"></span>
a substantial breakfast and they had to sit down
while she made them some pancakes and broiled a
fish her husband had caught in the brook the day
before. To these were added some blackberry jam
and some coffee. The Englishman apologized that
he could not offer his visitors any ale.</p>
<p class="calibre3">“I miss my measure for meals sadly,” he observed.
“But we have none in the wood and no
pot-house handy, so I have to rest content without
it.”</p>
<p class="calibre3">“Water is good enough for me,” answered Joseph
Morris. “I care for no liquor, saving it be a hot
toddy when I have been in the wet and cold and am
afraid of taking sick.”</p>
<p class="calibre3">The day was bright and the weather warmer
than it had been, and Mr. Morris and Dave rode off
in the best of spirits, the Risleys watching them
until a bend in the trail hid them from view. To
the Risleys the visit was an event to be remembered.
Perhaps no other white person would visit the lonely
cabin for weeks and perhaps not even a red man
would cross the threshold.</p>
<p class="calibre3">As the Morrises approached Winchester the cabins
of the pioneers increased, until several could be seen
at a time, far up on the mountain sides, or set snug
in the valley below. Winchester was a fairly large
trading-post, and here, at certain times in the year<span id="Page_38" title="[38]"></span>
the hunters, trappers and farmers did considerable
business.</p>
<p class="calibre3">When they entered the place they found that a
band of Indians had come in several hours before.
The red men had brought in the fruits of their summer
hunt, which they were exchanging for metal and
glass ornaments, highly colored but cheap blankets
and cloths, and liquor and sugar. The two latter
articles were in active demand, and many of the Indians
insisted on carrying the rum on the inside instead
of in bottles, and this made them exceedingly
noisy. Here and there a brave partly under the
influence of drink would become quarrelsome, but
the majority indulged in nothing more dangerous
than singing, whooping and dancing.</p>
<p class="calibre3">“Much drink, much good jolly time,” said one
red man, as he rolled up to Dave and caught the
youth by both shoulders. Then he insisted upon
rubbing his nose against Dave’s, a not unusual Indian
token of friendship.</p>
<p class="calibre3">“You’d be better to leave the drink alone,” returned
Dave, in disgust, as he tried to release himself.</p>
<p class="calibre3">“White man’s fire-water heap good,” grunted the
Indian. “Make Turtle Foot feel young again.”</p>
<p class="calibre3">“You may think so, but I don’t. Now let me go.”</p>
<p class="calibre3"><span id="Page_39" title="[39]"></span>“White boy no go yet. White boy drink with
Turtle Foot. Feel like big brave. See!”</p>
<p class="calibre3">As the Indian concluded he pulled from under his
blanket a large bottle still half full of rum. Holding
tight to Dave with one hand, he held the bottle in
the other and pulled the cork with his teeth. Then
he shoved the liquor to the lad.</p>
<p class="calibre3">“Take drink—heap good fire-water,” he grunted.
“Turtle Foot treat—Indian big heart.”</p>
<p class="calibre3">“Thank you, but I don’t wish to drink,” said
Dave, as calmly as he could. He was alone with the
red man, his uncle having gone inside the post, leaving
him in care of the horses. Near at hand were
half a dozen other Indians all whooping as if trying
to split somebody’s ears.</p>
<p class="calibre3">“White boy must drink with Turtle Foot,” insisted
the red man in an ugly manner.</p>
<p class="calibre3">“I won’t—and that’s an end on it!” cried Dave,
his temper rising. “Now let me go I tell you!”
And he gave the Indian a shove that sent him sprawling
flat on his back. At once the other Indians
stopped whooping and set up a roar at the expense
of their fallen companion.</p>
<p class="calibre3">“Turtle Foot has lost his legs,” said one, in the
Miami tongue. “He is as a pappoose in the hands
of the white boy.”</p>
<p class="calibre3">“Turtle Foot cannot drink fire-water like we can,”<span id="Page_40" title="[40]"></span>
said another. “And he cannot make the white boy
drink. He had better return to the squaws and sell
his fire-water for a bracelet,” and then another roar
went up.</p>
<p class="calibre3">With a snort like that of an angry beast, Turtle
Foot turned over on the ground and scrambled to
his feet. Fearing trouble, Dave started for the doorway
to the trading-post. Then he thought of the
horses tied some distance away and hesitated, fearing
to leave them unwatched. In another moment Turtle
Foot staggered up to him and caught him again
by the arm.</p>
<p class="calibre3">“White boy shall pay!” he cried, in a rage, and
now one hand slid under his blanket and came forth
again clutching a long hunting knife.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?c520b6b8